export default {
	items: [
		{
			name: 'セミナー主催会社一覧',
			url: '/offices',
			icon: 'icon-people'
		},
		{
			name: '開催中のセミナー一覧',
			url: '/books',
			icon: 'icon-book-open'
		},
		{
			name: 'お役立ちニュース',
			url: '/news',
			icon: 'icon-notebook'
		},
		/* {
			name: 'プレスリリース',
			url: '/press',
			icon: 'icon-energy'
		},*/
		{
			name: '国税庁新着ニュース',
			url: '/national_tax_agency',
			icon: 'icon-pin'
		},
		{
			name: '中小企業庁新着ニュース',
			url: '/small_medium_enterprise_agency',
			icon: 'icon-paper-clip'
		},
		{
			name: '過去のセミナー一覧',
			url: '/archives',
			icon: 'icon-calendar'
		},
		{
			name: '運営会社概要',
			url: 'https://about.tax-seminarbook.com/company/',
			icon: 'icon-info'
		},
	]
}



// WEBPACK FOOTER //
// ./resources/js/_nav.js